import { MiscUtil } from '../miscUtil'
import {requestWithPorxy} from "../http";

/**
 * 请求wfs元信息
 * @param {String} wfsUrl
 * @return {Array.<{name}>}
 */
export async function getCapabilities(wfsUrl) {
    if (wfsUrl.indexOf('?') > 0) {
        if (wfsUrl.indexOf('?http') > 0) {
            wfsUrl = wfsUrl + '?service=wfs'
        } else {
            wfsUrl = wfsUrl + '&service=wfs'
        }
    } else {
        wfsUrl = wfsUrl + '?service=wfs'
    }
    return new Promise((resolve, reject) => {
        GeoGlobe.Request.GET({
            url: wfsUrl,
            params: {
                request: 'getCapabilities',
                version: '1.0.0'
            },
            async: false,//true表示异步，false表示同步
            success: function (result) {
                const layers = []
                const format = new GeoGlobe.Format.WFSCapabilities()
                const obj = format.read(result.responseText)
                const featureTypes = obj.featureTypeList.featureTypes
                if (featureTypes.length !== 0) {
                    for (let i = 0; i < featureTypes.length; i++) {
                        const value = featureTypes[i]
                        layers.push(value)
                    }
                }
                resolve(layers)
            },
            failure: function () {
                error.log("查询失败...")
            }
        })
    })

    /* return MiscUtil.getDSWithPorxy(wfsUrl, {
         params: {
             request: 'getCapabilities',
             version: '1.0.0'
         }
     }).then(data => {
         const layers = []

         const format = new GeoGlobe.Format.WFSCapabilities()
         const obj = format.read(data)

         const featureTypes = obj.featureTypeList.featureTypes
         if (featureTypes.length !== 0) {
             for (let i = 0; i < featureTypes.length; i++) {
                 const value = featureTypes[i]
                 layers.push(value)
             }
         }
         return layers
     })*/
}

/**
 * 获取图层字段
 * @param {String} wfsUrl
 * @param {String} typeName
 */
export async function describeFeatureType(wfsUrl, typeName) {
    if (wfsUrl.indexOf('?') > 0) {
        if (wfsUrl.indexOf('?http') > 0) {
            wfsUrl = wfsUrl + '?service=wfs'
        } else {
            wfsUrl = wfsUrl + '&service=wfs'
        }
    } else {
        wfsUrl = wfsUrl + '?service=wfs'
    }
    return new Promise((resolve, reject) => {
        GeoGlobe.Request.GET({
            url: wfsUrl,
            params: {
                request: 'DescribeFeatureType',
                version: '1.0.0',
                typeName: typeName
            },
            async: false,//true表示异步，false表示同步
            success: function (result) {

                let parser = new GeoGlobe.Format.WFSDescribeFeatureType({
                    version: '1.0.0',
                    defaultVersion: '1.0.0'
                })
                let jsonObj = parser.read(result.responseText)
                let proPerties = {}
                if(jsonObj.featureTypes.length >0){
                    proPerties = jsonObj.featureTypes[0].properties
                }
                resolve(proPerties)
            },
            failure: function () {
                error.log("查询失败...")
            }
        })
    })


    /* return MiscUtil.fetchWithPorxy(wfsUrl, {
         params: {
             request: 'DescribeFeatureType',
             version: '1.0.0',
             typeName: typeName
         }
     }).then(data => {
         var parser = new GeoGlobe.Format.WFSDescribeFeatureType({
             version: '1.0.0',
             defaultVersion: '1.0.0'
         })
         var jsonObj = parser.read(data)
         /!**
          * @type {Array.<{type}>}
          *!/
         var proPerties = jsonObj.featureTypes[0].properties
         return proPerties
     })*/
}

export async function getFeatureValues(wfsUrl, typeName, fields) {
    if (wfsUrl.indexOf('?') > 0) {
        wfsUrl = wfsUrl + '&SERVICE=wfs';
    } else {
        wfsUrl = wfsUrl + '?SERVICE=wfs';
    }
    // wfsUrl = wfsUrl + '?SERVICE=WFS';
    return requestWithPorxy(wfsUrl, {
        params: {
            REQUEST: 'GetFeature',
            VERSION: '1.0.0',
            TYPENAME: typeName,
            PROPERTYNAME: fields,
            RESULTTYPE: "result",
            OUTPUTFORMAT: "XML"
        }
    }).then(data => {
        const parser = new GeoGlobe.Format.GML({
            version: '1.0.0',
            defaultVersion: '1.0.0',
        });
        // var result = []
        // for (let i = 0; i < jsonObj.length; i++) {
        //     result.push(parseFloat(jsonObj[i].data[field]))
        // }
        // result.sort(function(a, b) {
        //     return a - b
        // })

        return parser.read(data);
    });
}
